module.exports = __webpack_public_path__ + "img/cancel.f8ccb989.png";